/** biome-ignore-all lint/suspicious/noExplicitAny: allow any */
import {useAutoAnimate} from '@formkit/auto-animate/react';
import React, {FC, ReactElement, useRef} from 'react';
import {useImpression} from '~/common/hooks/useImpression';
import {willChildReturnNull} from '~/common/utils';

interface ModuleProps {
  children: ReactElement;
  moduleName: string;
  impressionEvent?: string;
  isPreview?: boolean;
  readonly?: boolean;
  [key: string]: any;
}

export const Module: FC<ModuleProps> = ({
  children,
  moduleName,
  impressionEvent = undefined,
  isCreateEditPreview,
  readonly,
  ...acyclicalProps
}) => {
  const tracking: Record<string, any> = {};
  const trackingRef = useRef();

  if (impressionEvent) {
    tracking.ref = trackingRef;
    useImpression(trackingRef, impressionEvent);
  }

  const [moduleAnimation] = useAutoAnimate({
    duration: 350,
    easing: 'ease-in-out',
  });

  if (willChildReturnNull(children)) {
    return null;
  }

  return (
    <div
      className={`module ${moduleName} ${isCreateEditPreview ? 'preview' : ''}`}
      data-qa-id={`${moduleName}-module`}
      id={`module-${moduleName}`}
      {...tracking}
      ref={moduleAnimation}
    >
      {React.cloneElement(children, {
        ...acyclicalProps,
        readonly,
        isCreationFlow: !window.location.pathname.startsWith('/event'),
      })}
    </div>
  );
};
